import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../store';
import SharedFooter from '@ecri/react-components/Footer';

interface FooterProps {
    membersUrl?: string;
    useRelativeMemberLinks?: boolean;
  }

const Footer: React.FC<FooterProps> = () => {
  const user = useSelector((state: AppState) => state.auth.user);
  const [loggedIn, setLoggedIn] = useState(!(user?.expired ?? true));
  const [contactLink, setContactLink] = useState('');

  useEffect(() => {
    setLoggedIn(!(user?.expired ?? true));
  }, [user]);

  useEffect(() => {
    setContactLink(loggedIn ? "https://home.ecri.org/clientcontactus" : "https://home.ecri.org/pages/ecri-contact-us-form");
  }, [loggedIn])

  return (
    <SharedFooter
      membersUrl=""     
      useRelativeMemberLinks
      contactUsLink={contactLink}
    />
  );
};

export default Footer;
